import type { BackendRouteDefinition } from '../types';
import type { UpdateMerchant } from '@cloudFunctions/functions/payments/updateMerchant';

export interface UpdateMerchantRequestData {
  merchantId: UpdateMerchant.RequestData['merchantId'];
  body: Omit<UpdateMerchant.RequestData, 'merchantId'>;
}

/**
 * Kept isolated so the Phase 3 admin Finix migration can flip this route's
 * transport without touching shared admin route tables.
 */
export const updateMerchantRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/merchants/:merchantId',
  params: (requestData: UpdateMerchantRequestData) => ({
    merchantId: requestData.merchantId,
  }),
  body: (requestData: UpdateMerchantRequestData) => requestData.body,
} as const satisfies BackendRouteDefinition;
